export default "__VITE_ASSET__BBzYA8Ym__"